import React from "react";
import "./HLogoStrip.scss";
import PropTypes from "prop-types";

export const HLogoStrip = ({ title, logos, className = "" }) => {
  return (
    <section className={`hireart-ds-logo-strip ${className || ""}`}>
      <h2>{title}</h2>
      <div className="hireart-ds-logo-strip-window">
        <section className="hireart-ds-logo-strip-canvas">
          {logos.map((logo, i) => (
            <div className="hireart-ds-logo-strip-slide" key={i} data-index={i}>
              {logo}
            </div>
          ))}
        </section>
      </div>
    </section>
  );
};

HLogoStrip.propTypes = {
  links: PropTypes.array,
};

